import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { BooleanInput } from 'admin-on-rest/lib/mui';

const HeadersWidget = props =>
  props.options.enumOptions.map(option => (
    <Field
      key={`field_${option.value}`}
      name={`title${option.value}`}
      value={option.value}
      component={BooleanInput}
      label={option.label}
    />
  ));
HeadersWidget.propTypes = {
  value: PropTypes.shape({
    filename: PropTypes.string,
    projectId: PropTypes.number
  }),
  onChange: PropTypes.func
};

export default HeadersWidget;



// WEBPACK FOOTER //
// ./src/components/HeadersWidget.js